import { createContext, useState } from "react";

export const ArchivedRecordsContext = createContext();

const ArchivedRecordsProvider = ({ children }) => {

    const [isArchivedView, setIsArchivedView] = useState(false);
    
    return (
        <ArchivedRecordsContext.Provider value={{ isArchivedView, setIsArchivedView }}>
            {children}
        </ArchivedRecordsContext.Provider>
    );
};

export default ArchivedRecordsProvider;
